export default "__VITE_ASSET__ByZ984K___"